import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import axios from 'axios';

const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // حذف توکن
    localStorage.removeItem('token');
    axios.defaults.headers.common['Authorization'] = '';

    // نمایش نوتیفیکیشن
    notification.success({
      message: 'Sign Out Successful',
      description: 'You have successfully logged out of your account.',
      duration: 2, // مدت زمان نمایش نوتیفیکیشن
      showProgress:true
    });

      navigate('/auth/sign-in');
   
  }, [navigate]);

 
};

export default SignOut;
